const blobToDataURL = (blob, callback) => {
  var a = new FileReader();
  a.onload = function (e) {
    callback(e.target.result);
  }
  a.readAsDataURL(blob);
}

export {
  blobToDataURL,
}


// WEBPACK FOOTER //
// ./src/utils/images.js